import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isMobile, isTablet } from 'react-device-detect';
import Image from 'app/Components/Shared/Image/image';
import './ActivateEsimPage.scss';
import wifiIcon from './images/wifi-icon.svg';
import esimIcon from './images/esim-icon2.svg';
import deviceSelectionIcon from './images/device-selection-icon.svg';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { goToPage, reportDWH } from '../../EsimQrCodeBlockSlice';

const DEVICE_SELECTION_STEP = 0;
const WIFI_STEP = 1;
const SIM_REMOVAL_STEP = 2;

const getInitialStep = () => (isMobile || isTablet ? DEVICE_SELECTION_STEP : WIFI_STEP);

const ActivateEsimPage = (props) => {
    const [internalStep, setInternalStep] = useState(getInitialStep);
    const step = props.step !== undefined ? props.step : internalStep;
    const setStep = props.setStep || setInternalStep;
    const [installOnThisDevice, setInstallOnThisDevice] = useState(false);

    useEffect(() => {
        if (step === DEVICE_SELECTION_STEP) {
            setInstallOnThisDevice(false);
            props.reportDWH({
                actionType: 'Device Selection Page',
                status: 'Ongoing',
                messageText: 'Device Selection Page Displayed',
            });
        }
        if (step === WIFI_STEP) {
            props.reportDWH({
                actionType: 'WiFi Msg Page',
                status: 'Ongoing',
                messageText: 'WiFi Msg Page Displayed',
            });
        }
        if (step === SIM_REMOVAL_STEP) {
            props.reportDWH({
                actionType: 'SIM Removal Msg Page',
                status: 'Ongoing',
                messageText: 'SIM Removal Msg Page Displayed',
            });
        }
    }, [step]);

    let btnText = '';
    let title = '';
    let subtitle = '';
    let img = null;
    let isDeviceSelection = false;
    let isWifiStep = false;

    switch (step) {
        case DEVICE_SELECTION_STEP:
            isDeviceSelection = true;
            title = 'על איזה מכשיר להתקין את ה-eSIM?';
            img = deviceSelectionIcon;
            btnText = 'על המכשיר שבידיי';
            break;
        case WIFI_STEP:
            isWifiStep = true;
            title = 'האם המכשיר שלך מחובר ל-Wi-Fi?';
            img = wifiIcon;
            btnText = 'מחובר, אפשר להמשיך';
            break;
        case SIM_REMOVAL_STEP:
            title = 'יש להוציא את ה-SIM הפיזי מהמכשיר';
            subtitle = 'אם אין SIM פיזי במכשיר לא נדרש להוציא';
            img = esimIcon;
            btnText = 'הוצאתי, אפשר להמשיך';
            break;
        default:
    }

    return (
        <div className='replace-sim-to-esim-page-wrapper'>
            <div className={`activate-esim-page ${isDeviceSelection ? 'activate-esim-page--device-selection' : ''} ${isWifiStep ? 'activate-esim-page--wifi' : ''} ${subtitle ? 'activate-esim-page--sim-removal' : ''}`}>
                <Image src={img} className='icon' alt='' />
                <div className='title'>{title}</div>
                {subtitle && <div className='subtitle'>{subtitle}</div>}

                <div className='button-wrapper'>
                    <BtnSubmit
                        text={btnText}
                        onclick={isDeviceSelection ? handleThisDevice : handlePageContinue}
                        formid='esim-qr-code-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                    {isDeviceSelection && (
                        <div className='other-device-link'>
                            <a href='#' onClick={handleOtherDevice}>על מכשיר אחר</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    function handleThisDevice() {
        props.reportDWH({
            actionType: 'Device Selection Page',
            status: 'Ongoing',
            messageText: 'My Device Button Clicked',
        });
        setInstallOnThisDevice(true);
        setStep(WIFI_STEP);
    }

    function handleOtherDevice(e) {
        e.preventDefault();
        props.reportDWH({
            actionType: 'Device Selection Page',
            status: 'Ongoing',
            messageText: 'Other Device Button Clicked',
        });
        props.goToPage('instructionsPage');
    }

    function handlePageContinue() {
        switch (step) {
            case WIFI_STEP:
                props.reportDWH({
                    actionType: 'WiFi Msg Page',
                    status: 'Ongoing',
                    messageText: 'WiFi Msg Page Button Clicked',
                });
                setStep(SIM_REMOVAL_STEP);
                break;
            case SIM_REMOVAL_STEP:
                props.reportDWH({
                    actionType: 'SIM Removal Msg Page',
                    status: 'Ongoing',
                    messageText: 'SIM Removal Msg Page Button Clicked',
                });
                if (installOnThisDevice) {
                    props.goToPage('installEsimOnMobilePage');
                } else {
                    props.goToPage('instructionsPage');
                }
                break;
            default:
        }
    }
};

const mapDispatchToProps = {
    goToPage,
    reportDWH,
};

export default connect(null, mapDispatchToProps)(ActivateEsimPage);
